import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MaintenanceFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M7.16 19.7C6.3 20.56 4.86 20.56 4 19.7C3.14 18.84 3.1 17.46 3.96 16.6L11.16 9.4C10.78 7.9 11.22 6.32 12.32 5.22C13.54 4 15.36 3.58 17 4.2L17.5 4.38L14.32 7.56L16.26 9.46L19.42 6.32L19.6 6.86C20.18 8.44 19.76 10.28 18.56 11.46C17.46 12.58 15.8 13.02 14.28 12.58L7.16 19.7Z" />
    </SvgIcon>
  );
});
